
<script>
    export default {
        methods: {
            async fetchUser(query) {
                const search = query === null ? '' : query
                const response = await fetch(route('users.ajax-list') + '?search='+ search)
                
                return await response.json();
            },
        },
    }
</script>
